import React, { memo, useMemo } from 'react'
import { Spinner } from 'transfix-ui/components/Spinner'
import { List, Typography } from 'transfix-ui/core'
import LaneAgreementListItem from './LaneAgreementListItem'
import { useLaneAgreementsForCarrierQuery } from './graphql/LaneAgreementsForCarrier'

interface ILaneAgreementsProps {
  carrierApplicationId: string
}

const LaneAgreements = memo<ILaneAgreementsProps>(({ carrierApplicationId }) => {
  const { data, loading } = useLaneAgreementsForCarrierQuery({
    variables: {
      carrierApplicationId,
    },
  })

  // get all nodes that have a defined shipper rate and lane agreement
  const sourcedCarrierRateNodes = useMemo(
    () =>
      data?.sourcedCarrierRates?.nodes
        ?.map(node => node!)
        .filter(node => node?.shipperRate?.id && node?.latestLaneAgreement) ?? [],
    [data?.sourcedCarrierRates?.nodes]
  )

  return (
    <div className='mt4'>
      <Typography className='mb1' variant='subtitle2'>
        Lane Agreements
      </Typography>

      <List disablePadding>
        {loading ? (
          <Spinner />
        ) : (
          sourcedCarrierRateNodes.map(
            ({ id: sourcedCarrierRateId, latestLaneAgreement, shipperRate }) => (
              <LaneAgreementListItem
                key={sourcedCarrierRateId}
                laneAgreement={latestLaneAgreement!}
                shipperRateId={shipperRate!.id}
              />
            )
          )
        )}
      </List>
    </div>
  )
})

export default LaneAgreements
